import React, { useEffect, useState } from "react";
import Header from "../components/common/Header/index";
import Menu from "../components/common/Menu/index";
import useSize from "@hooks/common/useSize";
import PageLoader from "@components/common/PageLoader";
import errorfourzero from "@assets/images/404.svg";
import StatusMsg from "@components/common/StatusMsg";
import { withRouter } from "react-router-dom";
import { generalStore } from "store/generalStore";
import { getUserType } from "store/userType";
import { getFromStorage } from "utils/storage";

const AuthLayout = (props, { userType }) => {
  const winDimensions = useSize();
  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const setChangePasswordModal = generalStore(
    (state) => state.setChangePasswordModal,
  );
  const userData =
    getUserType((state) => state.userData) || getFromStorage("user_data");

  const menuOpenHandle = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    } else {
      setIsMenuOpen(true);
    }
  };

  const [isMenuOpenMobile, setIsMenuOpenMobile] = useState(true);

  const menuOpenHandleMobile = () => {
    if (isMenuOpenMobile) {
      setIsMenuOpenMobile(false);
      document.body.classList.add("cm-overflow-hidden");
    } else {
      setIsMenuOpenMobile(true);
      document.body.classList.remove("cm-overflow-hidden");
    }
  };

  const mobileMenuCloseOnBodyHandleChange = () => {
    setIsMenuOpenMobile(true);
  };
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    // Cleanup function
    return () => clearTimeout(timeout);
  }, []); // Run only on component mount

  useEffect(() => {
    window.scrollTo(0, 0);
    if (userData?.password_Reset == "False") {
      setChangePasswordModal(true);
    }
  }, []);

  return (
    <React.Fragment>
      <Header
        isMenuOpen={isMenuOpen}
        menuOpenHandle={menuOpenHandle}
        menuOpenHandleMobile={menuOpenHandleMobile}
        isMenuOpenMobile={isMenuOpenMobile}
        setIsMenuOpenMobile={setIsMenuOpenMobile}
      />
      <div
        className={`lyt-content ${isMenuOpen ? "menu-open" : ""} ${
          winDimensions[0] <= 1024 && !isMenuOpenMobile
            ? "mobile-menu-open"  
            : ""
        }`}
      >
        <Menu isMenuOpenMobile={isMenuOpenMobile} isMenuOpen={isMenuOpen} />
        {isLoading ? (
          <PageLoader />
        ) : (
          <div className="content-wrap">{props.children}</div>
        )}

        <span
          className="cm-backdrop"
          onClick={mobileMenuCloseOnBodyHandleChange}
        ></span>
      </div>
      {/* <div className="lyt-error">
        <StatusMsg
          imgUrl={errorfourzero}
          title={"Something went wrong."}
          desc={" Sorry, We can't find a page you're looking for. "}
          btnTitle={"Go Back"}
          // btnOnclick={}
        />
      </div> */}
    </React.Fragment>
  );
};

export default AuthLayout;
